// ─────────────────────────────────────────────────────────────────────────────
// OnsitePM Shared PDF Design System — Tokens (library-agnostic)
// ─────────────────────────────────────────────────────────────────────────────

// COLORS (Apple-refined palette matching PaymentRequestDocument.jsx)
export const COLORS = {
  black: '#1f2937',        // softened black — headers, pill text
  gray900: '#1f2937',
  gray700: '#4b5563',      // body labels
  gray500: '#71717a',      // secondary text, footer
  gray400: '#9ca3af',
  gray300: '#e4e4e7',      // dividers
  gray200: '#f1f5f9',      // table row borders
  gray100: '#f3f4f6',
  gray50: '#fafafa',       // zebra rows
  white: '#ffffff',
  orange: '#ed7340',       // accent — TOTAL NET only, or notable highlights
  // ── Added to match DP inline values ────────────────────────────────────────
  zinc400: '#a1a1aa',          // header tax-info text (zinc-400)
  tableSubHeaderBg: '#374151', // table sub-header background (gray-700)
  offWhite: '#f5f5f7',         // table header text (Apple off-white)
  hairline: '#d4d4d8',         // header divider (zinc-300)
};

// TYPOGRAPHY (units in points for react-pdf, mm for jsPDF — pt used everywhere here)
export const FONTS = {
  title:        { size: 17,  weight: 'bold',    letterSpacing: 1.0 },
  subtitle:     { size: 8,   weight: 'regular', letterSpacing: 3   },
  sectionLabel: { size: 9,   weight: 'bold',    letterSpacing: 0.8 },
  body:         { size: 9,   weight: 'regular'                     },
  small:        { size: 7.5, weight: 'regular'                     },
  micro:        { size: 7,   weight: 'regular'                     },
};

// SPACING (mm-based; converted per-library as needed)
export const SPACING = {
  pageMargin:   15,   // page horizontal margin — used by DailyLogPage.jsx (jsPDF). DO NOT CHANGE.
  pageMarginPt: 36,   // react-pdf page margin in pt (matches DP paddingHorizontal:36)
  headerHeight: 30,   // header band height
  sectionGap:   8,
  rowPadding:   3,
};

// BRANDING TEXT (i18n-friendly)
export const BRAND = {
  poweredBy: {
    fr: 'Généré avec OnsitePM',
    en: 'Generated with OnsitePM',
  },
  pageLabel: {
    fr: (n, total) => `Page ${n} sur ${total}`,
    en: (n, total) => `Page ${n} of ${total}`,
  },
};
